module.exports = __webpack_public_path__ + "img/shirt-3.7e098422.jpg";